import axios from "axios";

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    // Количество приходит с api/user, чтобы не грузить список документов на каждой странице
    unviewedCount(state, getters, rootState) {
      return rootState.auth.user ? rootState.auth.user.countUnviewedDocs || 0 : 0;
    },
  },

  mutations: {
    SET_LIST(state, value) {
      state.list = value;
    },
    SET_VIEWED(state, id) {
      const doc = state.list.find((el) => el.id === id);

      if (doc) {
        doc.is_viewed = true;
      }
    },
  },

  actions: {
    async fetchDocs({ commit, dispatch }) {
      try {
        const { data } = await axios.get("api/documents");
        commit("SET_LIST", data);
        dispatch("setUnviewedCount", data.filter((doc) => !doc.is_viewed).length);
      } catch (error) {
        console.warn("Failed fetch [store/docs/fetchDocs]", error);
      }
    },

    async markViewed({ commit, dispatch, getters }, doc) {
      if (doc.is_viewed) {
        return;
      }

      // Отмечаем сразу, чтобы бейдж пропал без задержки
      commit("SET_VIEWED", doc.id);
      dispatch("setUnviewedCount", Math.max(getters.unviewedCount - 1, 0));

      try {
        await axios.post(`api/documents/${doc.id}/views`);
      } catch (error) {
        console.warn("Failed fetch [store/docs/markViewed]", error);
      }
    },

    setUnviewedCount({ commit, rootState }, count) {
      if (rootState.auth.user) {
        commit("auth/SET_USER", { ...rootState.auth.user, countUnviewedDocs: count }, { root: true });
      }
    },
  },
};
